import { useCallback, useRef } from 'react';
import { useApolloClient } from '@apollo/client/react';
import { useNavigate } from 'react-router-dom';

// Returns a callback that loads the "next" resource of a series and navigates
// to it, falling back to the list page when the series is complete.
export default function useNextResource(options) {
  const client = useApolloClient();
  const navigate = useNavigate();
  const config = useRef(options);
  config.current = options;

  return useCallback(async () => {
    const { query, variables, nextKey, pathFor, fallbackPath } = config.current;
    // Drop variables that are not known yet (e.g. while the resource is loading).
    const cleanVariables = Object.fromEntries(
      Object.entries(variables || {}).filter(([, value]) => value !== undefined && value !== null)
    );
    try {
      const { data } = await client.query({
        query,
        variables: cleanVariables,
        fetchPolicy: 'network-only'
      });
      const next = data?.[nextKey];
      navigate(next ? pathFor(next) : fallbackPath);
    } catch {
      navigate(fallbackPath);
    }
  }, [client, navigate]);
}
